import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { DumpingTimeLineChart } from './components/DumpingTimeLineChart';
import { useState } from 'react';
import { AssetWiseTimeLineChart } from './components/AssetWiseTimelineChart';
import { PlanComparison } from '../components/PlanComparisonCard';
import { useTranslation } from 'react-i18next';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TimelineStep = () => {
  const { t } = useTranslation();
  const [view, setView] = useState<'assetwise' | 'dumping'>('assetwise');

  return (
    <Box
      height={'100%'}
      maxHeight={'100%'}
      display={'flex'}
      flexDirection={'column'}
      gap={3}
      mb={20}
    >
      <Box
        component="header"
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'start'}
      >
        <Box>
          <Typography>{t('cdp_timeline_description')}</Typography>
        </Box>
      </Box>
      <PlanComparison />
      <Box width={'100%'} position={'relative'}>
        <Box
          display="flex"
          justifyContent="center"
          position={'absolute'}
          top={12}
          right={16}
          zIndex={100}
        >
          <ToggleButtonGroup
            value={view}
            exclusive
            size="small"
            onChange={(_, newView) => {
              if (newView) setView(newView);
            }}
          >
            <ToggleButton
              sx={{
                textTransform: 'none',
                padding: '2px 6px',
              }}
              value="assetwise"
            >
              {t('asset_timeline')}
            </ToggleButton>
            <ToggleButton
              sx={{
                textTransform: 'none',
                padding: '2px 6px',
              }}
              value="dumping"
            >
              {t('dumping_timeline')}
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {view === 'assetwise' ? (
          <AssetWiseTimeLineChart />
        ) : (
          <DumpingTimeLineChart />
        )}
      </Box>
    </Box>
  );
};
